@if (hasItems) {
  <section>
    <nav class="breadcrumb-nav container-fluid" aria-label="breadcrumb">
      <div class="breadcrumb">
        @if (showHome) {
          <span class="breadcrumb-item">
            <a title="home" [routerLink]="['/']">
              <span i18n="@@HOME">Home</span>
            </a>
          </span>
        }
        @for (breadcrumb of breadcrumbItems; track trackByItems($index, breadcrumb); let isLast = $last) {
          @if (!isLast) {
            <span class="breadcrumb-item">
              <a [routerLink]="breadcrumb.path">
                {{ breadcrumb.label }}
              </a>
            </span>
          }
          @if (isLast && !shouldHideHomeBreadcrumb) {
            <span class="breadcrumb-item">
              {{ breadcrumb.label }}
            </span>
          }
        }
      </div>
    </nav>
  </section>
}
